export default {
  name: "Google",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  g: [
    {
      fill: "#318af5",
      d:
        "M27.52 16.27c0 3.5-1.2 6.48-3.3 8.56l-.28.26h-3.88v-3c1.18-.8 2-1.95 2.33-3.31l.07-.32H16v-4.64h11.3c.14.78.22 1.6.22 2.45z",
    },
    {
      fill: "#3da751",
      d:
        "M23.94 25.1A11.46 11.46 0 0 1 16 28a12 12 0 0 1-10.54-6.27l-.18-.34v-3.11h4A7.15 7.15 0 0 0 16 23.23c1.48 0 2.76-.36 3.79-.98l.27-.17 3.88 3.01z",
    },
    {
      fill: "#fdb900",
      d:
        "M9.29 13.72a7.21 7.21 0 0 0-.12 4.2l.12.36-4.01 3.1a12 12 0 0 1-.2-10.36l.2-.4h4v3.1z",
    },
    {
      fill: "#ea3e36",
      d:
        "m24.03 7.13-3.44 3.44A6.49 6.49 0 0 0 16 8.77a7.14 7.14 0 0 0-6.62 4.67l-.1.28-4-3.1a12 12 0 0 1 18.45-3.77l.3.28z",
    },
  ],
}
